import React, { useState, useEffect, useRef, useCallback } from "react";
import Grid from "@mui/material/Grid2";

import { 
  CampaignChar,
  Character,
} from "@dndModels";

import API from "@dndUtilities/system_api";

import DandDButtonBox from "@dndComponents/DandDButtonBoxSimple";
import CharacterInput from "./CharacterInput";
import FlexBox from "@components/layout/FlexBox";
import LoadingBox from "@components/input/LoadingBox";
import CheckBox from "@components/input/CheckBox";
import AddButton from "@components/input/buttons/icon_buttons/AddButton";

const api = API.getInstance();

interface Props {
}

export default function CharactersInput({ }: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [archives, setArchives] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const load = useCallback(async () => {
    if (api.user) {
      if (api.user.my_characters.length === 0) {
        api.user.my_characters = await api.getPlayerObjects<Character>({ data_type: "character" });
      }
      for (const char of api.user.my_characters) {
        if (!char.campaign) {
          let c_char = await api.getCampaignObject<CampaignChar>({ data_type: "campaign_char", filter: { char_id: char._id }});
          if (c_char) {
            const campaign = await api.getCampaign({ campaign_id: c_char.campaign_id, include: ["players","characters"] });
            if (campaign) {
              const c_char_id = c_char._id;
              c_char = campaign.c_chars.find(o => o._id === c_char_id);
            }
            if (c_char) {
              char.c_char = c_char;
            }
          }
        }
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      });
    }
  }, [fetched, load]);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  if (!fetched || loading) {
    return (<LoadingBox />);
  }
  if (api.user) {
    return (
      <FlexBox direction="column">
        { api.user && 
          <FlexBox direction="row">
            <FlexBox xs_expand={0} className="header centered">
              Characters
            </FlexBox>
            <FlexBox>
              <AddButton className="padded"
                fab
                disabled={ processing || !api.online } 
                onClick={ async () => {
                  if (api.user) {
                    setProcessing(true);
                    const new_char = new Character();
                    new_char.owner_id = api.user._id;
                    new_char.c_options.copy(api.default_c_options);
                    const res = await api.createCharacter(new_char);
                    if (res && res.body.id) {
                      api.user.my_characters.push(new_char);
                    } else {
                      console.log(res);
                    }
                    setProcessing(false);
                  }
                }}
              />
            </FlexBox>
            <FlexBox>
              <DandDButtonBox name="Create Sidekick" 
                disabled={ processing || !api.online }  
                onClick={ async () => {
                  if (api.user) {
                    setProcessing(true);
                    const new_char = new Character();
                    new_char.owner_id = api.user._id;
                    new_char.spirit.sidekick = true;
                    new_char.c_options.copy(api.default_c_options);
                    const res = await api.createCharacter(new_char);
                    if (res && res.body.id) {
                      api.user.my_characters.push(new_char);
                    } else {
                      console.log(res);
                    }
                    setProcessing(false);
                  }
                }}
              />
            </FlexBox>
          </FlexBox>
        }
        <FlexBox>
          <CheckBox
            name="View Archives"
            value={archives}
            onChange={setArchives}
          />
        </FlexBox>
        { !reloading && 
          <>
            <FlexBox>
              <Grid container spacing={0} direction="row">
                { api.user.my_characters.filter(o => o.archived === archives).map(char => {
                  return (
                    <Grid size={{ xs:12, sm: 6, md: 4, lg: 3 }} key={char._id}>
                      <CharacterInput
                        char={char} 
                        onUpdated={() => { setReloading(true); }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </FlexBox>
          </>
        }
      </FlexBox>
    ); 
  } else {
    return <></>;
  }
}
